import { createFileRoute, useParams } from "@tanstack/react-router"
import { StudentDuoExamResults } from "@/pages/cursisten/$studentId/examenresultaten"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/examenresultaten/",
)({
  component: StudentDuoExamResultsRoute,
})

function StudentDuoExamResultsRoute() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return <StudentDuoExamResults studentId={Number(studentId)} />
}
